export const environment = {
    name: 'ci',
    apiUrl: 'https://frc-ci-api.firstinspires.org',
    username: 'FRC_RegionalPool_CI ',
    apikey: '8F6173F1-338B-487E-A0DE-144568CC2E9C'
  };